import { bindable } from 'aurelia-framework';

class ProductCategoriesContainer {
  @bindable selectedAccount = null;
  @bindable selectedProduct = null;
  @bindable route = '#';
  loading = false;
  categories = null;
  /**
   * @param {AppErrorPublisher}    appErrorPublisher    To publish errors to the UI.
   * @param {errorParser}          errorParser          Used for error parsing.
   * @param {ProductFeedsProducts} productFeedsProducts To get the FeedsProducts.
   */
  constructor(appErrorPublisher, errorParser, productFeedsProducts) {
    'inject';

    this._appErrorPublisher = appErrorPublisher;
    /**
     * The parser the container will use to format possible errors.
     * @type {ParserrorWrapper}
     * @access protected
     * @ignore
     */
    this._productCategoriesErrorParser = errorParser.wrap();
    this._productFeedsProducts = productFeedsProducts;
  }
  selectedAccountChanged() {
    if (!this.loading && this.selectedProduct) {
      this._loadCategories();
    }
  }
  selectedProductChanged() {
    if (!this.loading && this.selectedAccount) {
      this._loadCategories();
    }
  }
  _loadCategories() {
    this.loading = true;
    this._productFeedsProducts.getProductCategories(
      this.selectedAccount.id,
      this.selectedProduct.id,
    )
    .then((categories) => {
      this.categories = categories;
    })
    .catch((error) => {
      const parsedError = this._productCategoriesErrorParser(
        error,
        'There was an error loading the categories',
      );

      this._appErrorPublisher.notify(error, parsedError.message);
    })
    .then(() => {
      this.loading = false;
    });
  }
}

export { ProductCategoriesContainer };
